import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getDistanceElevationList as getDistanceElevationListApi,
	getDistanceElevationListQuery as getDistanceElevationListQueryApi,
	getDistanceElevationItem as getDistanceElevationItemApi,
	addNewDistanceElevationApi,
	updateDistanceElevationApi,
	deleteDistanceElevationApi,
} from '../../helpers/distance_elevation/api_helper';

export const getDistanceElevationList = createAsyncThunk(
	'distanceElevation/getDistanceElevationList',
	async () => {
		try {
			const response = await getDistanceElevationListApi();
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las distancias y desniveles.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getDistanceElevationListQuery = createAsyncThunk(
	'distanceElevation/getDistanceElevationListQuery',
	async params => {
		try {
			const response = getDistanceElevationListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getDistanceElevationItem = createAsyncThunk(
	'distanceElevation/getDistanceElevationItem',
	async ({ id, populate = [] }) => {
		try {
			const response = await getDistanceElevationItemApi(id, populate);
			return response;
		} catch (error) {
			toast.error('Error al obtener la distancia y desnivel.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewDistanceElevation = createAsyncThunk(
	'distanceElevation/addNewDistanceElevation',
	async distance_elevation => {
		try {
			const response = await addNewDistanceElevationApi(distance_elevation);
			const data = response.data || response;
			
			toast.success('Distancia y desnivel agregado exitosamente.', {
				autoClose: 3000,
			});
			return data;
		} catch (error) {
			toast.error('Error al agregar distancia y desnivel.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateDistanceElevation = createAsyncThunk(
	'distanceElevation/updateDistanceElevation',
	async distance_elevation => {
		try {
			const response = await updateDistanceElevationApi(distance_elevation);
			const data = response.data || response;
			
			toast.success('Distancia y desnivel actualizado exitosamente.', {
				autoClose: 3000,
			});
			return data;
		} catch (error) {
			toast.error('Error al actualizar distancia y desnivel.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteDistanceElevation = createAsyncThunk(
	'distanceElevation/deleteDistanceElevation',
	async distance_elevation => {
		try {
			const response = await deleteDistanceElevationApi(distance_elevation._id);
			toast.success('Distancia y desnivel eliminado exitosamente.', {
				autoClose: 3000,
			});
			return distance_elevation;
		} catch (error) {
			toast.error('Error al eliminar distancia y desnivel.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
